import { ForumsPanel } from "@/components/ForumsPanel";
export default function ClientForums() {
  return <div className="lg:mt-0 mt-10"><ForumsPanel testid="client-forums" /></div>;
}
